import { useEffect } from "react";
import { input } from "../../helper";
import Option from "../Option";
import Question from "../Question";

export default function MmcqCard({
  color = "",
  data,
  number,
  correctAnswer,
  setCorrectAnswer,
}) {
  const handleClick = (e) => {
    if (correctAnswer.includes(e.target.value)) {
      correctAnswer = correctAnswer.filter(
        (answer) => answer !== e.target.value
      );
      setCorrectAnswer(correctAnswer);
    } else {
      setCorrectAnswer([...correctAnswer, e.target.value]);
    }
  };

  //Uncheck all the options when a new data is rendered
  useEffect(() => {
    setCorrectAnswer([]);
    const radios = document.querySelectorAll(".question-fields .radio");
    radios.forEach((radio) => {
      radio.checked = false;
    });
  }, [number]);

  return (
      <Question
        color={color}
        index={number}
        question={data}
        label={"Select Multiple Options"}
      >
        {data.options.map((option, index) => {
          return (
            <Option
              key={index}
              option={option}
              image={data.images && data.images[`op${index + 1}`]}
              select={handleClick}
              styles={input(color)}
              checkMarkStyles={input(color, index)}
            />
          );
        })}
      </Question>
  );
}
